import { SalesChannel } from '../../enum';
import produce from 'immer';
import { StateProps } from './interface';
import { ActionType } from './enum';
import { handleInitStore, handleOffersSuccess, handleSelectOption } from './helpers/reducerHelper';
import { Actions } from './action';

export const initialState: StateProps = {
    error: undefined,
    selectedOption: {
        hardware: undefined,
        subscription: undefined,
        hardwareId: undefined,
        subscriptionId: undefined,
    },
    tariffs: [],
    salesChannel: SalesChannel.CONSUMER,
};

const appReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case ActionType.INIT_STORE:
                handleInitStore(draft, action);
                break;
            case ActionType.SET_SALESCHANNEL:
                const { subscriptionId, hardwareId } = draft.selectedOption;

                draft.salesChannel = action.payload;
                handleSelectOption(draft, subscriptionId, hardwareId);
                break;
            case ActionType.GET_TARIFF_SUCCESS:
                handleOffersSuccess(draft, action.payload);
                break;
            case ActionType.SET_ERROR:
                draft.error = action.error;
                break;
            case ActionType.SELECT_OPTION:
                handleSelectOption(draft, action.subscriptionId, action.hardwareId);
                break;
        }
    });

export default appReducer;
